<template>
  <div>
    <md-field>
      <label for="tipoDeVazamento">Tipo do Vazamento</label>
      <md-select
        id="tipoDeVazamento"
        v-model="vazamento.tipoDeVazamento"
        name="tipoDeVazamento"
        @md-selected="handleChange"
      >
        <md-option value="Ramal"> Ramal </md-option>
        <md-option value="Rede"> Rede </md-option>
        <md-option value="Outro"> Outro </md-option>
      </md-select>
    </md-field>

    <md-field v-if="vazamento.tipoDeVazamento === 'Outro'">
      <label for="tipoDeVazamentoOutro">Especificar o Tipo de Vazamento</label>
      <md-input
        v-model="vazamento.tipoDeVazamentoOutro"
        @change="handleChange"
      />
    </md-field>

    <md-field>
      <label for="magnitudeDoVazamento">Magnitude do Vazamento</label>
      <md-select
        id="magnitudeDoVazamento"
        v-model="vazamento.magnitudeDoVazamento"
        name="magnitudeDoVazamento"
        @md-selected="handleChange"
      >
        <md-option value="Pequeno"> Pequeno </md-option>
        <md-option value="Médio"> Médio </md-option>
        <md-option value="Grande)"> Grande </md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>
export default {
  name: 'FormularioVazamentoSig',
  props: {
    data: Object,
  },
  data() {
    return {
      vazamento: {
        tipoDeVazamento: 'Rede',
        tipoDeVazamentoOutro: null,
        magnitudeDoVazamento: 'Pequeno',
      },
    }
  },
  beforeMount() {
    if (this.data) {
      this.vazamento = { ...this.data }
    }
  },
  mounted() {
    this.handleChange()
  },
  methods: {
    handleChange() {
      this.$emit('change', {
        isValid: true,
        data: { ...this.vazamento },
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
